import React, { useEffect } from 'react';
import Layout from '../components/layout/layout';
import HeroSection from '../components/help/sections/hero';
import CommonSection from '../components/help/sections/common';
import VideoSection from '../components/help/sections/video';
import ResourceSection from '../components/help/sections/resource';

export default function Help({ initialData }) {
  useEffect(() => {
    // Get title from initialData if available, otherwise use fallback
    const pageTitle = initialData?.meta?.title || 'WymBee Support Hub - Help Center';
    document.title = pageTitle;
  }, [initialData]);

  return (
    <Layout initialData={initialData}>
      <HeroSection />
      <CommonSection />
      <VideoSection />
      <ResourceSection />
    </Layout>
  );
}